<template>
	<div v-if="viewLoaded">
		<h1 class="mb-3 agency-project-panel-view-title"> Składanie wniosku do naboru {{contestConfiguration.name}} ({{contestConfiguration.shortName}})</h1>
		<h2 class="mb-3 agency-project-panel-view-title">{{projectData.title || ""}}</h2>
		<v-stepper v-model="viewData.step">
			<v-stepper-header>
				<v-divider></v-divider>
				<template v-for="(section, index) in totalNumberOfSteps">
					<v-stepper-step
						edit-icon="check"
						:editable="viewData.step >= index+1" :title="viewData.titles.allTitles[index]"
						:complete="viewData.step > index+1" :step="index+1" v-bind:key="index">
					</v-stepper-step>
					<v-divider v-bind:key="index+100"></v-divider>
				</template>
			</v-stepper-header>
			<v-stepper-items>
				<v-btn @click="nextStep(index)" v-if="!isLastStep" :disabled="savingProject" color="primary" class="right">
					<v-icon class="mr-2 white--text">arrow_forward</v-icon>
					Dalej
				</v-btn>

				<v-btn @click="stepBack(index)" v-if="!isFirstStep" :disabled="savingProject" color="default" class="right">
					<v-icon class="mr-2 white--text">arrow_back</v-icon>
					Cofnij
				</v-btn>
				<h1 class="stepTitle">{{stepTitle}}</h1>
				<vue-form-generator
					name="generator"
					ref="vfg"
					:model="formGenerator.currentModel"
					:options="formGenerator.formOptions"
					:schema="formGenerator.currentSchema"
					v-if="viewData.showGenerator"
					aria-label="label for icon"
				/>
				<agency-application-name
					v-if="stepTitle === 'Podstawowe informacje'"
					v-model="projectData.title"
				/>
				<agency-application-english-name
					v-if="stepTitle === 'Podstawowe informacje'"
					v-model="projectData.englishTitle"
				/>

				<agency-choose-project-type
					v-if="stepTitle === 'Podstawowe informacje'"
					:contest-id="contestData.id"
					v-model="projectData.projectType"
					ref="projectType"
				></agency-choose-project-type>

				<agency-priority-tree
					v-if="stepTitle === 'Podstawowe informacje'"
					v-model="projectData.prioritiesData"
					@countriesChanged="changeCountries"
					:agency-id="projectData.agencyId"
					:many-accreditation-countries="contestConfiguration.manyAccreditationCountries"
					:many-tasks="contestConfiguration.manyTasks"
					:many-priorities="contestConfiguration.manyPriorities"
					:many-areas="contestConfiguration.manyAreas"
					ref="priorityTree"
				></agency-priority-tree>


				<agency-choose-funding
					ref="funding"
					:input="projectData.prioritiesData"
					v-if="stepTitle === 'Statystyka'"
					:countries-changed.sync="countriesChanged"
					v-model="projectData.financesData"
					:agency-id="projectData.agencyId"
				></agency-choose-funding>

				<br>

				<choose-d-a-c
					v-if="stepTitle === 'Statystyka' && contestConfiguration.dacCodesEnabled"
					type="AGENCY_CONTEST"
					ref="chooseDac"
					:contest-id="contestData.id"
					v-model="projectData.dacCodes"
				></choose-d-a-c>

				<AgencyActionsCosts
					v-if="stepTitle === 'Koszty'"
					v-model="projectData.costs"
					:actions="projectData.actions"
					:contest-id="contestData.id"
					ref="costs"
				></AgencyActionsCosts>

				<agency-financial-table-hint
					v-if="stepTitle === 'Koszty'"
					:hint="contestConfiguration.financialTableHint"
				></agency-financial-table-hint>

				<agency-choose-actions
					:taken-serial-numbers="projectData.takenSerialNumbers"
					v-if="stepTitle === 'Działania projektowe'"
					ref="actions"
					v-model="projectData.actions"
				></agency-choose-actions>

				<choose-geographical-locations
					v-if="stepTitle === 'Działania projektowe'"
					ref="locations"
					v-model="projectData.locations"
				></choose-geographical-locations>

				<agency-activities-table-hint
					v-if="stepTitle === 'Działania projektowe'"
					:hint="contestConfiguration.activitiesTableHint"
				></agency-activities-table-hint>

				<agency-choose-beneficiaries
					v-if="stepTitle === 'Statystyka'"
					v-model="projectData.beneficiariesData"
					ref="beneficiaries"
				></agency-choose-beneficiaries>

				<v-stepper-content :step="index+1" v-bind:key="index+20"
					v-for="(section, index) in totalNumberOfSteps">

					<v-btn @click="$router.go(-1)" v-if="isFirstStep" color="blue">
						<v-icon class="mr-2 white--text">close</v-icon>
						Anuluj
					</v-btn>

					<v-btn @click="stepBack(index)" v-if="!isFirstStep" :disabled="savingProject" color="default">
						<v-icon class="mr-2 white--text">arrow_back</v-icon>
						Cofnij
					</v-btn>

					<v-btn @click="nextStep(index)" v-if="!isLastStep" :disabled="savingProject" color="primary">
						<v-icon class="mr-2 white--text">arrow_forward</v-icon>
						Dalej
					</v-btn>

					<v-btn @click="saveProject(true)" :disabled="savingProject" color="blue">
						<v-icon class="mr-2 white--text">save</v-icon>
						Zapisz wniosek
					</v-btn>

					<v-btn color="primary"
						@click="send" :disabled="savingProject"
						v-if="isLastStep">
						<v-icon class="mr-2 white--text">send</v-icon>
						Zakończ i wyślij wniosek
					</v-btn>
				</v-stepper-content>
			</v-stepper-items>
		</v-stepper>
		<egranty-error-list-popup
			title="Nie udało się wysłać wniosku:"
			:error-list="sendOfferErrors.messages"
			:is-open="sendOfferErrors.showPopup"
			@close="sendOfferErrors.showPopup = false"
		/>
		<agency-project-confirmation-dialog :action="sendProject" :dialog-model="viewData.sendProjectDialog"
			action-label="Wyślij" content="Upewnij się, że wypełniłeś poprawnie formularz zanim zatwierdzisz wniosek.
				Po zatwierdzeniu nie będzie możliwości edycji!" header="Wysyłka wniosku" icon="send"
			@close-confirmation="viewData.sendProjectDialog = false"/>
	</div>
</template>
<script>
	import Vue from "vue";
	import {genericFormUtil} from "@/utils/genericFormUtil";
	import VueFormGenerator from "vue-form-generator";
	import {Api} from "@/api";
	import {AgencyProject} from "@/api/generated/AgencyProject";
	import AgencyPriorityTree from "./components/AgencyPriorityTree";
	import ChooseDAC from "../offer/components/ChooseDAC";
	import AgencyChooseFunding from "./components/AgencyChooseFunding";
	import AgencyChooseBeneficiaries from "../agencyContest/components/AgencyChooseBeneficiaries";
	import AgencyChooseProjectType from "./components/AgencyChooseProjectType";
	import ChooseGeographicalLocations from "../offer/components/ChooseGeographicalLocations";
	import AgencyChooseActions from "./components/AgencyChooseActions";
	import AgencyActionsCosts from "./components/AgencyActionsCosts";
	import AgencyProjectConfirmationDialog from "./components/AgencyProjectConfirmationDialog";
	import AgencyApplicationName from "./components/AgencyApplicationName";
	import AgencyApplicationEnglishName from "./components/AgencyApplicationEnglishName";
	import EgrantyErrorListPopup from "../../../genericComponents/EgrantyErrorListPopup";
	import AgencyFinancialTableHint from "./components/AgencyFinancialTableHint";
	import AgencyActivitiesTableHint from "./components/AgencyActivitiesTableHint";

	Vue.use(VueFormGenerator);


	export default {
		name: "AgencyProjectView",
		components: {
			AgencyFinancialTableHint,
			AgencyActivitiesTableHint,
			EgrantyErrorListPopup,
			AgencyApplicationEnglishName,
			AgencyApplicationName,
			AgencyProjectConfirmationDialog,
			AgencyActionsCosts,
			AgencyChooseActions,
			ChooseGeographicalLocations,
			AgencyChooseProjectType,
			AgencyChooseBeneficiaries,
			AgencyChooseFunding,
			ChooseDAC,
			AgencyPriorityTree,
		},
		watch: {
			"formGenerator.currentModel": {
				// byc moze trzeba bedzie zrefaktoryzowac to, odpala sie to co zmiane znaku
				handler() {
					if (this.viewLoaded && this.isGenericPersistentStep) {
						this.applyGenericPersistentForm();
					}
				},
				deep: true,
			},

			"viewData.step": { // krok, może zostać zmieniony poprzez kliknięcie w stepper-header-step lub poprzez nextStep
				handler() {
					this.changingStepAction();
					this.$vuetify.goTo(0, {easing: 'linear'});
				},
			},
		},

		computed: {

			viewLoaded() {
				return this.projectDataLoaded && this.contestConfigurationLoaded;
			},


			stepTitle() {
				return this.viewData.titles.allTitles[this.viewData.step - 1];
			},

			isFirstStep() {
				return this.viewData.step === 1;
			},

			isLastStep() {
				return this.viewData.step === this.totalNumberOfSteps;
			},

			totalNumberOfSteps() {
				return this.numberOfFirstNotModuleSteps + this.numberOfGenericPersistentSteps + this.numberOfLastNotGenericSteps;

			},

			numberOfFirstNotModuleSteps() {
				return this.viewData.titles.firstNotModuleStepTitles.length;
			},

			numberOfConstFieldsModuleSteps() {
				return 0;
			},

			numberOfGenericPersistentSteps() {
				return this.contestConfiguration.persistentSchema.sections.length;
			},

			numberOfLastNotGenericSteps() {
				return this.viewData.titles.lastNotGenericStepTitles.length;
			},
		},

		data() {
			return {
				savingProject: false,
				sendOfferErrors: {
					showPopup: false,
					messages: [],
				},

				countriesChanged: false,

				contestData: {
					id: this.$route.params.id,
				},

				// tutaj pakujemy dane z konfiguracji konkursu
				contestConfiguration: {
					persistentSchema: null,
					manyAccreditationCountries: false,
					manyTasks: false,
					manyAreas: false,
					manyPriorities: false,
					activitiesTableHint: "",
					financialTableHint: "",
					name: "",
					shortName: "",
					dacCodesEnabled: true,
				},

				// tutaj pakujemy dane projektu
				projectData: {
					id: this.$route.params.projectId,
					genericModel: undefined,
				},

				formGenerator: {
					currentSchema: {},
					currentModel: {},
					formOptions: {
						validateAfterLoad: false,
						validateAfterChanged: true,
						validateAsync: true,
					},
					currentConditionalHashes: undefined,
				},

				viewData: {
					step: 1,
					showGenerator: false,
					titles: {
						firstNotModuleStepTitles: ["Podstawowe informacje", "Statystyka", "Działania projektowe", "Koszty"],
						lastNotGenericStepTitles: ["Składanie wniosku"],
						allTitles: [],
					},
					sendProjectDialog: false,
				},
				contestConfigurationLoaded: false,
				projectDataLoaded: false,

			};
		},
		created() {
			this.loadData();
		},

		methods: {

			async loadData() {
				await Api.syncGet(this,
					"/agency-contest/project-configuration"
						+ "?contestId=" + this.contestData.id, successResponse => {
							this.initializeConfiguration(successResponse);
							this.contestConfigurationLoaded = true;
						}, () => {
						});

				AgencyProject.getData(
					this,
					this.projectData.id,
					response => {
						for (let field in response) {
							this.$set(this.projectData, field, response[field]);
						}
						this.initializeGenericModel(response);
						this.projectDataLoaded = true;
						this.viewData.step = this.projectData.step;
						this.initializeStepTitles();
						if (this.isGenericPersistentStep()) {
							this.applyGenericPersistentForm();
						}
					},
					errorResponse => this.$messagesBus.$emit("error", "Nie udało się wczytać projektu!", errorResponse),
				);
			},

			async validateExistingRef(name) {
				if (this.$refs[name] === undefined) {
					return true;
				}
				if (typeof this.$refs[name]["validate"] !== "function") {
					return true;
				}
				let res = await this.$refs[name].validate();
				return res === true;
			},

			async validateNonGeneric() {
				return await this.validateExistingRef("projectType") &&
					await this.validateExistingRef("priorityTree") &&
					await this.validateExistingRef("chooseDac") &&
					await this.validateExistingRef("actions") &&
					await this.validateExistingRef("costs") &&
					await this.validateExistingRef("projectType") &&
					await this.validateExistingRef("beneficiaries") &&
					await this.validateExistingRef("locations");
			},

			async nextStep() {
				let valid = await this.validate();
				valid &= await this.validateNonGeneric();
				if (!valid) {
					this.$messagesBus.$emit("error", "Formularz zawiera błędy");
					return;
				}
				this.saveInViewCurrentStepState();
				this.viewData.step = this.viewData.step + 1;
				this.projectData.step = this.viewData.step;
				this.changingStepAction();
				await this.saveProject(true);
			},

			stepBack() {
				this.saveInViewCurrentStepState();
				this.viewData.step = this.viewData.step - 1;
				this.projectData.step = this.viewData.step;
				this.changingStepAction();
			},

			send() {
				this.viewData.sendProjectDialog = true;
			},

			async validate() {
				let isValid = true;
				if (this.isConstFieldsFirstSteps()) {
					return isValid;
				}

				if (this.isGenericPersistentStep()) {
					let validationPromise = await this.validateGenericForm();
					if (validationPromise.length > 0) {
						isValid = false;
					}
					return isValid;
				}

				if (this.isLastNotGenericSteps()) {
					return isValid;
				}
				return isValid;
			},

			async validateGenericForm() {
				return this.$refs.vfg.validate();
			},

			saveInViewCurrentStepState() {

				if (this.isGenericPersistentStep()) {
					this.projectData.genericModel.sections[this.resolveSectionIndexInPersistentSchema()].fields = this.formGenerator.currentModel;
				}
			},

			initializeGenericModel(response) {
				this.projectData.genericModel = this.getPersistentModel(response);
			},

			changeCountries() {
				this.countriesChanged = true;
			},

			getPersistentModel(response) {
				if (response.persistentGenericModel) {
					return genericFormUtil.decodeSchema(response.persistentGenericModel);
				}
				return genericFormUtil.buildModelFromSchema(this.contestConfiguration.persistentSchema);
			},

			initializeConfiguration(response) {
				this.contestConfiguration.persistentSchema = this.getPersistentSchema(response);
				this.contestConfiguration.manyAccreditationCountries = response.manyAccreditationCountries;
				this.contestConfiguration.manyAreas = response.manyAreas;
				this.contestConfiguration.manyTasks = response.manyTasks;
				this.contestConfiguration.manyPriorities = response.manyPriorities;
				this.contestConfiguration.activitiesTableHint = response.activitiesTableHint;
				this.contestConfiguration.financialTableHint = response.financialTableHint;
				this.contestConfiguration.name = response.name;
				this.contestConfiguration.shortName = response.shortName;
				this.contestConfiguration.dacCodesEnabled = response.dacCodesEnabled;
			},

			initializeStepTitles() {

				this.viewData.titles.firstNotModuleStepTitles.forEach(title => {
					this.viewData.titles.allTitles.push(title);
				});
				this.viewData.titles.allTitles.push();

				for (let i = 0; i < this.numberOfGenericPersistentSteps; i++) {
					this.viewData.titles.allTitles.push(this.contestConfiguration.persistentSchema.sections[i].name);
				}
				this.viewData.titles.lastNotGenericStepTitles.forEach(title => {
					this.viewData.titles.allTitles.push(title);
				});
			},

			getPersistentSchema(response) {
				return genericFormUtil.decodeSchema(response.genericSchema);
			},

			changingStepAction() {
				if (this.isGenericPersistentStep()) {
					this.applyGenericPersistentForm();
					this.viewData.showGenerator = true;
				} else {
					this.viewData.showGenerator = false;
				}
			},

			isConstFieldsFirstSteps() {
				let step = this.viewData.step;
				if (step <= this.numberOfFirstNotModuleSteps) {
					return true;
				}
			},

			isGenericPersistentStep() {
				let step = this.viewData.step;
				return (step > this.totalNumberOfSteps - this.numberOfLastNotGenericSteps - this.numberOfGenericPersistentSteps) && (step <= this.totalNumberOfSteps - this.numberOfLastNotGenericSteps);
			},

			isLastNotGenericSteps() {
				let step = this.viewData.step;
				return (step >= this.totalNumberOfSteps - this.numberOfLastNotGenericSteps) && (step <= this.totalNumberOfSteps);
			},

			applyGenericPersistentForm() {
				let sections = this.projectData.genericModel.sections;
				let currentSectionIndex = this.resolveSectionIndexInPersistentSchema();
				this.formGenerator.currentModel = sections[currentSectionIndex].fields;
				let schema = genericFormUtil.getSectionSchemaFromSchema(this.contestConfiguration.persistentSchema, currentSectionIndex);
				if (genericFormUtil.sectionSchemaContainsConditionalField(schema)) {
					let schemaValues = sections[currentSectionIndex].fields;
					this.formGenerator.currentSchema = genericFormUtil.filterSchemaByConditionalFieldsValue(schema, schemaValues);
					let indexes = genericFormUtil.calculateIndexes(schema);
					this.formGenerator.currentConditionalHashes = genericFormUtil.getConditionalValueHashes(schema, indexes);
				} else {
					this.formGenerator.currentSchema = schema;
				}
				this.viewData.showGenerator = true;
			},

			resolveSectionIndexInPersistentSchema() {
				return this.numberOfGenericPersistentSteps - (this.totalNumberOfSteps - this.numberOfLastNotGenericSteps - this.viewData.step) - 1;
			},

			resolveSectionIndexInGenericModule() {
				return this.viewData.step - this.numberOfFirstNotModuleSteps - this.numberOfConstFieldsModuleSteps - 1;
			},

			resolveSectionIndexInConstFieldModule() {
				let step = this.viewData.step;
				return step - this.numberOfFirstNotModuleSteps - 1;
			},

			resolveSectionIndexInFirstConstSteps() {
				return this.viewData.step - 1;
			},

			resolveSectionIndexInLastConstSteps() {
				return this.numberOfLastNotGenericSteps - (this.totalNumberOfSteps - this.viewData.step);
			},


			async sendProject() {
				let projectDataCopy = this.prepareProjectDataToBeSent();

				AgencyProject.postSubmit(this, this.projectData.id, projectDataCopy,
					() => {
						this.$router.push("/app/agency-contest/" + this.contestData.id + "/my-project-list");
					},
					errorResponse => {
						this.sendOfferErrors.messages = errorResponse.message.split("\n");
						this.sendOfferErrors.messages.pop();
						this.sendOfferErrors.showPopup = true;
					});
			},

			async saveProject (showMessage) {
				this.savingProject = true;
				let projectDataCopy = this.prepareProjectDataToBeSent();
				await AgencyProject.put(this, this.projectData.id, projectDataCopy,
					successResponse => {
						if (showMessage) this.$messagesBus.$emit("success", "Projekt zapisany pomyślnie", successResponse);
						this.savingProject = false;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się zapisać projektu", errorResponse);
						this.savingProject = false;
					});
			},

			prepareProjectDataToBeSent() {
				let projectDataCopy = JSON.parse(JSON.stringify(this.projectData));
				projectDataCopy.persistentGenericModel = genericFormUtil.encodeSchema(projectDataCopy.genericModel);
				delete projectDataCopy.genericModel;
				return projectDataCopy;
			},
		},
	};
</script>
<style scoped>
	.stepTitle {
		margin: 20px;
	}

	.financialHint {
		margin-left: 20px;
		font-size: 12px;
		font-style: italic;
		white-space: pre;
		display: flex;
	}

	.agency-project-panel-view-title {
		margin-left: 20px;
	}
</style>
